/**
 * Created by csaba.adam on 2017. 07. 14..
 */
import angular from 'angular';

import { NiceUrlService } from './nice-url.service';

const MODULE_NAME = 'niceUrlService';

export default angular.module(MODULE_NAME, []).service('niceUrlService', NiceUrlService).name;


